import React from "react";
import Icon from "../../../../common/components/Icon/Icon";
import cx from "classnames";

interface IHeaderCashbackProps {
    totalCashback: number;
    className?: string;
}

const HeaderCashback: React.FC<IHeaderCashbackProps> = (props) => {
    const { totalCashback, className } = props;

    return (
        <div
            className={cx(
                {
                    [className]: !!className
                },
                "layout-flex-row"
            )}>
            {totalCashback > 0 && (
                <React.Fragment>
                    <Icon id="CashbackGold" className="icon-cashback space-m" />
                    <div className="layout-flex-column--justify-evenly-spaced">
                        <span>Your Cashback!</span>
                        <span
                            className="text-cashback-price"
                            data-cashback={totalCashback}>
                            ${totalCashback.toFixed(2)}
                        </span>
                    </div>
                </React.Fragment>
            )}
        </div>
    );
};

export default HeaderCashback;
